import { FeedItemWithRank } from '@warebee/shared/dataset-queries';
import { t } from 'i18next';
import { WizardStepConfig } from '../../common/types';
import { ProductCategory } from '../../simulation/store/abc/simulation.ABC.types';

export const feedActivityDurationTypes = ['default', 'custom'] as const;
export type FeedActivityDurationType =
  (typeof feedActivityDurationTypes)[number];

export const feedActivityViewTypes = ['total', 'latest', 'route'] as const;
export type FeedActivityViewType = (typeof feedActivityViewTypes)[number];

export type FeedMenuItemId =
  | 'feed-menu-activity'
  | 'feed-menu-filter-preset'
  | 'feed-menu-setup';

export type FeedMenuItem = WizardStepConfig<FeedMenuItemId>;

// Activity Feed Tabs
// ———————————————————————————————————
export const activityFeedTabIds = [
  'tab-feed-activity',
  'tab-feed-summary',
  'tab-feed-process',
  'tab-feed-resources',
  'tab-feed-workforce',
  'tab-feed-items',
  'tab-feed-orders',
  'tab-feed-heatmaps',
  'tab-feed-stats',
  'tab-feed-allocate',
  'tab-feed-more',
  'tab-feed-kpi',
  'tab-feed-settings-data',
  'tab-feed-settings-policies',
  'tab-feed-settings-datepicker',
  'tab-feed-settings-general',
  'tab-feed-settings-filters',
  'tab-feed-settings-setup',
] as const;

export type ActivityFeedTabId = (typeof activityFeedTabIds)[number];

export type FeedItemWithABCRank = FeedItemWithRank & {
  category: ProductCategory;
};

export const feedHeatmapMetrics = ['locationVisits', 'abc', 'agents'] as const;

export type FeedHeatmapMetric = (typeof feedHeatmapMetrics)[number];

export const groupByTimeOptions = [
  { label: t('By Day', { ns: 'app' }), value: 'byDay' },
  { label: t('By Hour', { ns: 'app' }), value: 'byHour' },
  { label: t('By Week', { ns: 'app' }), value: 'byWeek' },
];

//  Feed Events Panel - Display Options switch
export const feedDisplayOptions = [
  { label: t('Stats', { ns: 'app' }), value: 'stats' },
  { label: t('Events', { ns: 'app' }), value: 'all' },
  { label: t('Issues', { ns: 'app' }), value: 'issues' },
];

export const feedAnalysedJobDisplayOptions = [
  { label: t('Stats', { ns: 'app' }), value: 'stats' },
  { label: t('Events', { ns: 'app' }), value: 'all' },
  { label: t('Issues', { ns: 'app' }), value: 'issues' },
];
